import { Css } from "@homebound/beam";
import React from "react";
import { createDesignPackagesUrl } from "src/RouteUrls";
import { PageHeader } from "src/routes/layout/PageHeader";

type NewDesignPackageWizardPageProps = unknown;
export function NewDesignPackageWizardPage({ children }: React.PropsWithChildren<NewDesignPackageWizardPageProps>) {
  return (
    <>
      <PageHeader
        title="Create a new Design Package"
        breadcrumb={[
          { label: "Design Packages", href: createDesignPackagesUrl() },
          { label: "Create a New Design Package", href: "" }, // href: "" does what?
        ]}
        xss={Css.px4.mb0.$}
      />
      <div /* fullpage, scrollable area, gray */ css={Css.df.fdc.aic.p4.w100.h100.oys.pbPx(215).bgGray100.$}>
        <div css={Css.df.fdc.aifs.gap3.hmaxc.maxwPx(800).$}>{children}</div>
      </div>
    </>
  );
}
